import { INVALIDATE_OPERATEURS } from 'actions/invalidationTags';
import { ApiMananger } from "actions/rtkquery";
import { GET_OPERATEURS_API_ROUTE } from "routes/api/endpoints";

const operateursApi = ApiMananger.injectEndpoints({
    endpoints: (build) => ({

    getOperateurs: build.query({
        query: ({ dossier_id }) => `${GET_OPERATEURS_API_ROUTE}?dossier_id=${dossier_id}&page=1&page_size=100`,
        providesTags: [INVALIDATE_OPERATEURS],
    }),
    getOperateurId: build.query({
        query: ({ id }) => `${GET_OPERATEURS_API_ROUTE}?id=${id}`,
        providesTags: [INVALIDATE_OPERATEURS],
    }),
}),
});

export const {
    useGetOperateursQuery,
    useGetOperateurIdQuery
} = operateursApi;
